import "./index.scss";

export const FormCheckbox = ({
  checked,
  onChange,
  id,
  name,
  customClassName = "",
  label
}) => {
  return (
    <div className={`form-checkbox-container ${customClassName}`}>
      <label className="form-checkbox-label" htmlFor={id}>
        {label}
      </label>
      <input
        type="checkbox"
        id={id}
        name={name}
        className="form-checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
    </div>
  );
};
